<template>
    <div class="form_group_input--select--1of2">
        <select :name="`${type}_city`" v-model="address.city" @change="emitCity" :required="requeired">
            <option :value="null">縣市</option>
            <option :value="city" v-for="city in cities">{{ city }}</option>
        </select>
        <span></span>
        <select :name="`${type}_state`" v-model="address.state" @change="emitState" :required="requeired">
            <option :value="null">鄉鎮區</option>
            <option :value="state" v-for="state in states">{{ state }}</option>
        </select>
    </div>
</template>

<script>
export default {
    name: "CityStateSelector",
    props: ["location", "type", "address", "requeired"],
    computed: {
        cities: function () {
            let citySet = new Set();
            let cities = [];

            this.location.forEach((local) => citySet.add(local["city"]));
            citySet.forEach((city) => cities.push(city));

            return cities;
        },
        states: function () {
            let that = this;
            if (this.address.city === null || this.address.city === "null") {
                this.$set(this.address, "state", null);
                this.emitState();
            }
            return this.location
                .filter(function (locale) {
                    return locale["city"] === that.address.city;
                })
                .map(function (locale) {
                    return locale["state"];
                });
        },
    },
    methods: {
        emitCity: function () {
            if (this.address.city === "null") {
                this.$set(this.address, "city", null);
            }
            this.$set(this.address, "state", null);
            return this.$emit("city", {
                type: this.type,
                city: this.address.city,
            });
        },
        emitState: function () {
            if (this.address.state === "null") {
                this.$set(this.address, "state", null);
            }
            return this.$emit("state", {
                type: this.type,
                state: this.address.state,
            });
        },
    },
};
</script>
